import { FC } from 'react'

import { ErrorRouteComponent, useParams } from '@tanstack/react-router'

import { Cluster, Typography } from '@forto-dev/phoenix-ui-core'
import { Spinner } from '@forto-dev/phoenix-ui-core/common'
import { Layout } from '@forto-dev/phoenix-ui-core/ship'

import { Back } from '@/fragments/back.tsx'
import { createErrorFallback } from '@/fragments/create-error-fallback.tsx'
import { Footer } from '@/fragments/footer.tsx'
import { Header } from '@/fragments/header.tsx'
import { Navigation } from '@/fragments/navigation'
import { useLocalisation } from '@/utils/localisation'

export const ShipmentLayout: FC = () => {
  return <Layout header={<Header />} navigation={<Back to="/" />} main={<Spinner size="lg" />} footer={<Footer />} />
}
export const ShipmentErrorComponent: ErrorRouteComponent = ({ error, reset }) => {
  const { id } = useParams({
    strict: false,
  })

  return (
    <Layout
      header={<Header />}
      navigation={<Back to="/" />}
      main={createErrorFallback(`An error occurred while loading shipment ${id}`)({ error, reset })}
      footer={<Footer />}
    />
  )
}

export const OverviewErrorComponent: ErrorRouteComponent = ({ error, reset }) => {
  const { translate } = useLocalisation()
  return (
    <Layout
      header={<Header />}
      navigation={<Navigation />}
      title={
        <Cluster gap={8} y="baseline">
          <Typography variant="h4">{translate('navigation.overview')}</Typography>
        </Cluster>
      }
      main={createErrorFallback(`An error occurred while loading shipments`)({ error, reset })}
      footer={<Footer />}
    />
  )
}
